<template>
  <CurrentsContourBarComponent v-if="displayCurrentsBar" />
  <WindContourBarComponent v-else-if="displayWindBar" />
  <WaveHeightContourBarComponent v-else-if="displayWaveBar" />
</template>

<script>
import { MeteoOptions } from "../../../../domain/weather_routing/meteo_options/enum";
import CurrentsContourBarComponent from "./CurrentsContourBarComponent.vue";
import WaveHeightContourBarComponent from "./WaveHeightContourBarComponent.vue";
import WindContourBarComponent from "./WindContourBarComponent.vue";

export default {
  components: {
    CurrentsContourBarComponent,
    WindContourBarComponent,
    WaveHeightContourBarComponent,
  },
  computed: {
    displayCurrentsBar() {
      return this.option == MeteoOptions.Currents;
    },
    displayWindBar() {
      return this.option == MeteoOptions.Wind;
    },
    displayWaveBar() {
      return this.option == MeteoOptions.Waves;
    },
  },
  props: {
    option: MeteoOptions,
  },
  data() {
    return {};
  },
};
</script>